import React, { memo } from "react";

const LockIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7 11V8a5 5 0 0110 0v3M6 11h12a1 1 0 011 1v8a1 1 0 01-1 1H6a1 1 0 01-1-1v-8a1 1 0 011-1z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5 13l4 4L19 7"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const QuestionTitle = memo(
  ({
    number,
    title,
    isExpanded,
    onToggle,
    selectedLabel,
    isDisabled,
    panelId,
    triggerId,
    isAnswered,
  }) => {
    const showDoneRing = isAnswered && !isExpanded && !isDisabled;

    const badge = (
      <span className="vh-accordion-step__badge-wrap">
        <span
          className={`services-picker__question-title-number vh-accordion-step__badge ${showDoneRing ? "vh-accordion-step__badge--done" : ""}`}
          aria-hidden="true"
        >
          {number}
        </span>
        {showDoneRing ? (
          <span className="vh-accordion-step__badge-done" title="Answered" aria-hidden="true">
            <CheckIcon />
          </span>
        ) : null}
      </span>
    );

    const content = (
      <>
        {badge}
        <span className="services-picker__question-title-text vh-accordion-step__text">
          <span className="vh-accordion-step__title title-h5">{title}</span>
          {selectedLabel ? (
            <span className="services-picker__selected-option vh-assessment__selected-chip">
              <span className="vh-assessment__selected-chip-inner">
                {selectedLabel}
              </span>
            </span>
          ) : null}
        </span>
        {isDisabled ? (
          <span className="vh-accordion-step__lock-cap" aria-hidden="true">
            <LockIcon />
          </span>
        ) : (
          <span className="vh-accordion-step__chevron" aria-hidden="true">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`vh-accordion-step__chevron-svg ${isExpanded ? "vh-accordion-step__chevron-svg--open" : ""}`}
            >
              <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        )}
      </>
    );

    if (isDisabled || !onToggle) {
      return (
        <div
          id={triggerId}
          className="services-picker__question-title title-h5 vh-accordion-step__trigger vh-accordion-step__trigger--disabled"
          aria-disabled="true"
        >
          {content}
        </div>
      );
    }

    return (
      <button
        type="button"
        className="services-picker__question-title title-h5 vh-accordion-step__trigger"
        onClick={onToggle}
        aria-expanded={isExpanded}
        aria-controls={panelId}
        id={triggerId}
      >
        {content}
      </button>
    );
  }
);

QuestionTitle.displayName = "QuestionTitle";

export default QuestionTitle;
